import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { EmojiPicker } from '@atlaskit/emoji/picker';
import Popup from '@atlaskit/popup';
import { PickerRender } from '../ufo';
import { Trigger } from './Trigger';
export var ReactionSummaryViewEmojiPicker = function ReactionSummaryViewEmojiPicker(_ref) {
  var emojiProvider = _ref.emojiProvider,
    onSelection = _ref.onSelection,
    emojiPickerSize = _ref.emojiPickerSize,
    disabled = _ref.disabled,
    reactionPickerTriggerIcon = _ref.reactionPickerTriggerIcon,
    tooltipContent = _ref.tooltipContent,
    onOpen = _ref.onOpen,
    reactionPickerTriggerText = _ref.reactionPickerTriggerText,
    setIsSummaryViewTrayEmojiPickerOpen = _ref.setIsSummaryViewTrayEmojiPickerOpen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var handleClick = function handleClick() {
    // ufo start reactions picker open experience
    PickerRender.start();
    var newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    setIsSummaryViewTrayEmojiPickerOpen && setIsSummaryViewTrayEmojiPickerOpen(newIsOpen);
    onOpen && onOpen();

    // ufo reactions picker opened success
    PickerRender.success();
  };

  /**
   * Event callback when the picker is closed
   * @param _id Optional id if an emoji button was selected or undefined if was clicked outside the picker
   */
  var close = useCallback(function (_id) {
    setIsOpen(false);
    setIsSummaryViewTrayEmojiPickerOpen && setIsSummaryViewTrayEmojiPickerOpen(false);
    // ufo abort reaction experience
    PickerRender.abort({
      metadata: {
        emojiId: _id,
        source: 'ReactionPicker',
        reason: 'close dialog'
      }
    });
  }, [setIsOpen, setIsSummaryViewTrayEmojiPickerOpen]);

  /**
   * Event callback when an emoji icon is selected
   * @param item selected item
   */
  var onEmojiSelected = useCallback(function (item) {
    // no emoji was selected
    if (!item.id) {
      return;
    }
    onSelection(item.id, 'emojiPicker');
    close(item.id);
  }, [onSelection, close]);
  return /*#__PURE__*/React.createElement(Popup, {
    testId: "reaction-summary-view-emoji-picker",
    isOpen: isOpen,
    placement: "bottom-start",
    offset: [-10, -34],
    onClose: function onClose() {
      return close();
    },
    content: function content() {
      return /*#__PURE__*/React.createElement(EmojiPicker, {
        emojiProvider: emojiProvider,
        onSelection: onEmojiSelected,
        size: emojiPickerSize
      });
    },
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(Trigger, _extends({}, triggerProps, {
        disabled: disabled,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        tooltipContent: tooltipContent,
        onClick: handleClick,
        showAddReactionText: true,
        reactionPickerTriggerText: reactionPickerTriggerText,
        fullWidthSummaryViewReactionPickerTrigger: true
      }));
    }
  });
};